import { Col, Row } from "react-bootstrap";

const InvoiceTotalPrices = ({ invoiceData, taxPercent }) => {
    const detailsCount = invoiceData
        .InvoiceDetailList
        .filter(d => !d.SignedForDelete)
        .length;
        if(detailsCount === 0)
        {
            return null;
        }
    return (
        <Row className="gap-1 m-0">

            <Col className="form-group invoice-totalprice-container">
                <label className="invoice-totalprice-label">قابل پرداخت (ریال)</label>
                <div className="invoice-totalprice-value">{invoiceData.InvoicePureTotalPrice?.toLocaleString("fa-IR")}</div>
            </Col>
            <Col className="form-group invoice-otherprice-container">
                <label className="invoice-totalprice-label">مبلغ ارزش افزوده</label>
                <div className="invoice-totalprice-value">{invoiceData.TaxFee.toLocaleString("fa-IR")}</div>
            </Col>
            <Col className="form-group  invoice-otherprice-container" style={{ maxWidth: "max-content" }}>
                <label className="invoice-totalprice-label">درصد ارزش افزوده</label>
                <div className="invoice-totalprice-value">{taxPercent}</div>
            </Col>
            <Col className="form-group invoice-otherprice-container">
                <label className="invoice-totalprice-label">مبلغ تخفیف</label>
                <div className="invoice-totalprice-value">{invoiceData.Discount.toLocaleString("fa-IR")}</div>
            </Col>
            <Col className="form-group invoice-otherprice-container">
                <label className="invoice-totalprice-label">جمع کالا</label>
                <div className="invoice-totalprice-value">{invoiceData.InvoiceTotalPrice.toLocaleString("fa-IR")}</div>
            </Col>
            <Col className="form-group invoice-otherprice-container" style={{ maxWidth: "max-content" }}>
                <label className="invoice-totalprice-label">تعداد اقلام</label>
                <div className="invoice-totalprice-value">{detailsCount}</div>
            </Col>
        </Row>
    )
}
export default InvoiceTotalPrices;